import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreService } from "../../api/apiServices";
import parseError from "../../utils/parseError";

const useRestoreService = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreSer,
        isPending: isRestore,
    } = useMutation({
        mutationFn: restoreService,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["services"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore service");
        },
    });

    return {
        restoreSer,
        isRestore,
    };
};

export default useRestoreService;
